<template>
  <div class="water" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px"></div>
    <div class="sq">
      <h2>我要加盟配送员</h2>
      <div>
        <p>必填项，请输入姓名</p>
        <input type="text" v-model="name"  />
      </div>
      <div class="code">
        <p>必填项，请输入联系电话</p>
        <input type="text" v-model="phone" />
      </div>
      <div class="code">
        <p>必填项，请输入联系地址</p>
        <input type="text" v-model="address" />
      </div>
    </div>
    <div class="btn" @click="update">立即申请</div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        userData:[],
        code:'',
        address:'',
        phone:'',
        name:''
      };
    },
    beforeMount() {
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      this.baseUrl = this.$host;
    },
    created(){
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/water');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }
      this.beforeMount();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      update:function(){
        var that = this;
        if(that.name == ''){
          alert('姓名不能为空');
          return false;
        }
        if(that.phone == ''){
          alert('联系电话不能为空');
          return false;
        }
        that.fullscreenLoading = true;
        var id = this.$route.query.id;
        this.axios({
          'url': that.$host+'home/water/apply',
          'method': 'post',
          params:{
            user_id:that.userData.id,
            username:that.name,
            phone:that.phone,
            address:that.address
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          alert('您已申请加盟成功，耐心等待客户经理联系');
          that.$router.push('index')
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .water{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }

  .water .sq{
    width:92%;
    margin:0 auto;
    height:300px;
    background: #FFFFFF;
    border-radius: 5px
  }


  .water h2{
    font-size:18px;
    padding:25px;
  }
  .water h2{
    font-size:18px;
    padding:25px;
  }
  .water input{
    width:85%;
    display:block;
    margin:0 auto;
    border:none;
    border-bottom:solid #f1f1f1 1px;
    outline:none;
    font-size:16px;
    height:35px
  }
  .water p{
    font-size:13px;
    color:#777;
    width:85%;
    display:block;
    margin:0 auto;
    padding-top:15px
  }
  .water .btn{
    height: 45px;
    background: #2F78FF;
    text-align: center;
    line-height: 45px;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    border-radius: 6px;
    width:92%;
    margin:0 auto;
    margin-top:50px
  }
  .water .code{
    position:relative
  }
  .water .code b{
    position:absolute;
    right:7%;
    top:5px;
    background:#fff;
    font-size:14px;
  }
  

</style>